import axios from 'axios';
import { TokenService } from '../services/storage.service';
import HasMake from '../services/hash.service';
import UserService from './user.service';
import router from '../router';

// Add a response interceptor
axios.interceptors.response.use(function (response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  }, function (error) {
    if(401 === error.response.status && TokenService.getToken()){
        UserService.clearUserSessionData()
        
        router.push('/login?redirect='+router.currentRoute.fullPath)
    }
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  });

const ApiService = {

    init(baseURL) {
        axios.defaults.baseURL = baseURL;
        this.setHeader();
    },

    setHeader() {

        if (TokenService.getToken()) {
            axios.defaults.headers.common["Authorization"] = "Bearer "+TokenService.getToken();
        }
        axios.defaults.headers.common["Content-Type"] = 'application/json';  
        axios.defaults.params = {};
        axios.defaults.params['locale'] = TokenService.getLocale()    
    },

    removeHeader() {
        axios.defaults.headers.common["Authorization"] = '';
    },

    get(resource, QS) {
        var params = QS || {};
        this.setHeader();
        return axios.get(resource, params);
    },

    post(resource, data) {
        this.setHeader();
        return axios.post(resource, data);
    },

    put(resource, data) {
        this.setHeader();
        return axios.put(resource, data);
    },

    delete(resource, QS) {
        var params = QS || {};
        this.setHeader();
        return axios.delete(resource, params);
    },

    /**
     * Perform a custom Axios request.
     *
     * data is an object containing the following properties:
     *  - method
     *  - url
     *  - data ... request payload
     *  - auth (optional)
     *    - username
     *    - password
    **/
    customRequest(data) {
        this.setHeader();
        return axios(data);
    },

    /**
     * Generate encrypted public key for all API request
     */
    generateApiKey() {
        var req = new XMLHttpRequest();
        req.open('GET', process.env.VUE_APP_ROOT_API + 'get-timestamp', false); 
        req.send();
        if(req.status == 200) {
            const res = JSON.parse(req.responseText);
            return HasMake.encrypt(`${process.env.VUE_APP_ENCRYPTKEY}||${res.data}`);
        }
    },

    customDiffRequestget(resource) {
        return axios.get(resource);
    },
    getDownLoadFileWithAuth(data) {
        return axios.get(data,{
            'responseType' : 'arraybuffer'
        });
    }
}

export default ApiService